// extracted by mini-css-extract-plugin
export default {"title":"Nr0sQ","rowTitle":"_1Q9MU","icons":"NGDFh","icon":"_1EyUM","row":"_3szso"};